<template>
  <div>
    <v-card>
      <v-card-title>
        <v-icon color="primary"> mdi-google-classroom </v-icon>
        <span class="pl-2">{{ $t('pages.classes') }}</span>
        <v-spacer></v-spacer>
        <create-button @create="showClassDialog"></create-button>
      </v-card-title>
      <v-data-table
        item-key="id"
        :loading="isLoading"
        loading-text="Loading... Please wait"
        :headers="headers"
        :items="classes"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :label="$t('pages.search')"
            class="mx-4"
          ></v-text-field>
        </template>
        <template v-slot:item.created_at="{ item }">
          <small>{{ item.created_at | moment('LL') }}</small> -
          <small class="text-muted">{{ item.created_at | moment('LT') }}</small>
        </template>
        <template v-slot:item.actions="{ item }">
          <template v-if="!$isDirector">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                small
                class="mr-2"
                @click="editClass(item)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>{{ $t('actions.edit') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                small
                @click="deleteClass(item, classes.indexOf(item))"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>{{ $t('actions.delete') }}</span>
          </v-tooltip>
          </template>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="classDialog" persistent max-width="600px">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ $t('pages.class_data') }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="name"
                      :rules="nameRules"
                      :label="$t('forms.name') + '*'"
                      :hint="$t('forms.name_of_the_class')"
                      required
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      v-model="school_id"
                      :rules="schoolIdRules"
                      :label="$t('forms.school') + '*'"
                      :items="schools"
                      item-text="name"
                      item-value="id"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeClassDialog">
                {{ $t('actions.close') }}
              </v-btn>
              <v-btn color="blue darken-1" text @click="createClass">
                {{ $t('actions.save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import CreateButton from '@/components/CreateButton.vue';

export default {
  components: { CreateButton },
  data() {
    return {
      classes: [],
      schools: [],
      isLoading: false,
      search: '',
      classDialog: false,
      valid: true,
      id: null,
      name: null,
      nameRules: [(v) => !!v || this.$t('forms.name_is_required')],
      school_id: null,
      schoolIdRules: [(v) => !!v || this.$t('forms.school_is_required')],
      headers: [
        // { text: this.$t('table.id'), value: 'id', align: 'start', filterable: false },
        { text: this.$t('table.name'), value: 'name' },
        { text: this.$t('table.school'), value: 'school.name' },
        { text: this.$t('table.created'), value: 'created_at' },
        { text: this.$t('table.actions'), value: 'actions', sortable: false },
      ],
    };
  },
  mounted() {
    this.loadClasses();
  },
  methods: {
    loadClasses() {
      this.isLoading = true;
      this.classes = [];
      axios
        .get(`/classes/all`)
        .then((response) => {
          this.classes = response.data;
        })
        .catch((error) => {
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_retrieving_classes'),
            type: 'error',
          });
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    validate() {
      return this.$refs.form.validate();
    },
    showClassDialog() {
      this.id = null;
      this.classDialog = true;
      this.$refs.form.reset();
    },
    closeClassDialog() {
      this.id = null;
      this.classDialog = false;
      this.$refs.form.reset();
    },
    createClass() {
      if (this.validate()) {
        this.isLoading = true;
        this.classDialog = false;
        axios
          .post(`/classes/create-edit`, {
            id: this.id,
            name: this.name,
            school_id: this.school_id,
          })
          .then(() => {
            this.loadClasses();
            this.$notify({
              title: this.$t('messages.success'),
              text: this.id
                ? this.$t('messages.updated')
                : this.$t('messages.created'),
              type: 'success',
            });
            // this.$swal(
            //   this.$t('messages.success'),
            //   this.id
            //     ? this.$t('messages.updated')
            //     : this.$t('messages.created'),
            //   'success'
            // );
          })
          .catch(() => {
            this.$notify({
              title: this.$t('messages.error'),
              text: this.$t('messages.error_while_creating'),
              type: 'error',
            });
            // this.$swal(
            //   this.$t('messages.error'),
            //   error.response.data.message,
            //   'error'
            // );
          })
          .then(() => {
            this.isLoading = false;
            this.school_id = null;
          });
      }
    },
    editClass(group) {
      this.id = group.id;
      this.name = group.name;
      this.school_id = group.school_id;
      this.classDialog = true;
    },
    deleteClass(group, index) {
      this.$swal
        .fire({
          title: this.$t('actions.delete'),
          text:
            this.$t('messages.are_you_sure_to_delete_the') +
            " ' " +
            group.name +
            " ' ? " +
            this.$t('messages.you_wont_be_able_to_revert_this') +
            '!',
          icon: 'error',
          showCancelButton: true,
          confirmButtonText: this.$t('actions.yes_delete_it'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteClassServer(group.id, index);
          }
        });
    },
    deleteClassServer(class_id, index) {
      axios
        .delete(`/classes/${class_id}`)
        .then(() => {
          this.classes.splice(index, 1);
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.deleted'),
            type: 'success',
          });
        })
        .catch(() => {
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_deleting'),
            type: 'error',
          });
          // this.$swal(
          //   this.$t('messages.error'),
          //   error.response.data.message,
          //   'error'
          // );
        })
        .then(() => {
          //this.isDeleting = false;
        });
    },
    getAllSchoolsList() {
      axios.get(`/schools/list`).then((response) => {
        this.schools = response.data;
      });
    },
  },
  watch: {
    classDialog: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) {
          this.getAllSchoolsList();
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped></style>
